import { fb, validators } from "../../../../lib/form";
import utils from "../../../../utils";

export function getSignupFormModel(data) {
  let stateList = utils.site.isNZ
      ? [
          { name: "Auckland", value: "NZ_AKL" },
          { name: "New Plymouth", value: "NZ_NPL" },
          { name: "Hawke's Bay", value: "NZ_HKB" },
          { name: "Wellington", value: "NZ_WGN" },
          { name: "Nelson", value: "NZ_NSN" },
          { name: "Marlborough", value: "NZ_MBH" },
          { name: "Westland", value: "NZ_WTC" },
          { name: "Canterbury", value: "NZ_CAN" },
          { name: "Otago", value: "NZ_OTA" },
          { name: "Southland", value: "NZ_STL" },
        ]
      : [
          { name: "NSW", value: "AU_NSW" },
          { name: "VIC", value: "AU_VIC" },
          { name: "QLD", value: "AU_QLD" },
          { name: "WA", value: "AU_WA" },
          { name: "SA", value: "AU_SA" },
          { name: "TAS", value: "AU_TAS" },
          { name: "ACT", value: "AU_ACT" },
          { name: "NT", value: "AU_NT" },
        ];
    stateList = stateList.sort((a, b) => a.name.localeCompare(b.name));
    stateList = [{ name: "Select...", value: "" }, ...stateList];
    // stateList = [{ name: "Select...", value: "" }, ...stateList];
  
  const model = fb.group({
    firstName: [
      data.firstName || "",
      [validators.Required()],
      { label: "First Name", type: "text" },
    ],
    lastName: [
      data.lastName || "",
      [validators.Required()],
      { label: "Last Name", type: "text" },
    ],  
    email: [
      data.email || "",
      [validators.Required(), validators.Email()],
      { label: "", type: "email" },
    ],
    state: [
      data.state || "",
      [validators.Required("Please select your State or Province.")],
      { label: "State/Province", type: "select", options: stateList },
    ],
  });

  return model;
}
